import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import {
  provideFluentDesignSystem,
  fluentListbox,
  fluentOption,
  fluentDialog,
  fluentButton,
} from "@fluentui/web-components";
import { DiagramComponent } from "./components/diagram/diagram.component";

import {
  fluentTab,
  fluentTabs,
  fluentTabPanel,
  fluentTooltip,
} from "@fluentui/web-components";
import { fluentMenu, fluentMenuItem } from "@fluentui/web-components";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "./services/auth.service";
import { BaseServiceService } from "./services/base-service.service";
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';

declare var fabric: any;

provideFluentDesignSystem().register(
  fluentMenu(),
  fluentMenuItem(),
  fluentListbox(),
  fluentOption(),
  fluentTab(),
  fluentTabs(),
  fluentTabPanel(),
  fluentDialog(),
  fluentButton(),
  fluentTooltip()
);

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild("dialogContainer") dialogContainer!: ElementRef;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private baseService: BaseServiceService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}
  
  ngOnInit(): void {
    (window as any).baseService = this.baseService;
    // Manejar el redirect de MSAL al nivel de la aplicación
    this.msalService.handleRedirectObservable().subscribe();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  dialogComponent: any;

  abrirDialogoDeLogin(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const dialog =
        this.dialogContainer.nativeElement.querySelector(".ms-Dialog");
      if (!dialog) {
        reject(new Error("Dialog element not found within dialog container."));
        return;
      }

      this.dialogComponent = new fabric["Dialog"](dialog);
      var SpinnerElements = document.querySelectorAll(".ms-Spinner");
      for (var i = 0; i < SpinnerElements.length; i++) {
        new fabric["Spinner"](SpinnerElements[i]);
      }
      this.dialogComponent.open();

      resolve();
    });
  }
}
